import type { PopulatedEntitySuggestion, DuplicateCandidatesRequest } from '@bliks-io/contracts';

export function buildDuplicateCandidatesRequest(
  suggestion: PopulatedEntitySuggestion
): DuplicateCandidatesRequest {
  if (suggestion.kind === 'system') {
    return {
      kind: 'system',
      payload: {
        name: suggestion.payload.name,
        category: suggestion.payload.category
      }
    };
  }
  return {
    kind: 'orgFunction',
    payload: {
      name: suggestion.payload.name,
      // department is optional on a OrgFunction suggestion (a role, or a dept-less
      // team, carries none).
      department: suggestion.payload.department?._id
    }
  };
}
